var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cluster-selection-container" }, [
    !_vm.clusterTool
      ? _c(
          "div",
          {
            staticClass: "cluster-selection-type",
            class: { active: _vm.selectionType === "point" },
            on: {
              click: function($event) {
                return _vm.setType("point")
              }
            }
          },
          [
            _c(
              "div",
              [
                _c("ClusterPointSVG", {
                  class: { active_svg: _vm.selectionType === "point" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "cluster-text" }, [
              _vm._v(_vm._s(_vm.$tc("Point", 1)))
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "cluster-selection-type",
        class: { active: _vm.selectionType === "polygon" && !_vm.creatable },
        on: {
          click: function($event) {
            return _vm.setType("polygon")
          }
        }
      },
      [
        _c(
          "div",
          [
            _c("ClusterPolygonSVG", {
              class: {
                active_svg: _vm.selectionType === "polygon" && !_vm.creatable
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "cluster-text" }, [
          _vm._v(_vm._s(_vm.$tc("Polygon", 1)))
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-89f23acc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89f23acc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/ObjectWindow/Cluster/SelectionTypeButtons.vue
// module id = null
// module chunks = 